export const EFFECTS = {
  PARALLAX: 'parallax',
  FIXED: 'fixed',
};
export const PARALLAX_MULTIPLIER = 0.3;
export const RESIZE_TIMEOUT = 100;
export const PARALLAX_UPDATE_ACTION = 'update';
